class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Function to check if the checkbox is checked
function isCheckboxChecked() {
  var checkbox = document.getElementById('agree');
  return checkbox.checked;
}

// Function to disable checkout buttons
function disableCheckoutButtons() {
  var checkoutButtons = document.querySelectorAll('.cart__checkout-button');
  checkoutButtons.forEach(function (button) {
    button.disabled = true;
  });
}

// Function to enable checkout buttons
function enableCheckoutButtons() {
  var checkoutButtons = document.querySelectorAll('.cart__checkout-button');
  checkoutButtons.forEach(function (button) {
    button.disabled = false;
  });
}

// Function to disable buttons within dynamic-checkout__content
function disableDynamicCheckoutButtons() {
  var dynamicCheckoutButtons = document.querySelectorAll('.dynamic-checkout__content button');
  dynamicCheckoutButtons.forEach(function (button) {
    button.disabled = true;
    button.style.pointerEvents = 'none';
  });
}

// Function to enable buttons within dynamic-checkout__content
function enableDynamicCheckoutButtons() {
  var dynamicCheckoutButtons = document.querySelectorAll('.dynamic-checkout__content button');
  dynamicCheckoutButtons.forEach(function (button) {
    button.disabled = false;
    button.style.pointerEvents = 'auto';
  });
}

// Function to handle checkbox change event
function handleCheckboxChange(event) {
  var isChecked = event.target.checked;
  var checkboxes = document.querySelectorAll('.terms-container input[type="checkbox"]');
  console.log(checkboxes);
  checkboxes.forEach(function (checkbox) {
    checkbox.checked = isChecked;
  });

  if (isChecked) {
    enableCheckoutButtons();
    enableDynamicCheckoutButtons();
  } else {
    disableCheckoutButtons();
    disableDynamicCheckoutButtons();
  }
}

// Add event listener to the checkboxes
var checkboxes = document.querySelectorAll('.terms-container input[type="checkbox"]');
checkboxes.forEach(function (checkbox) {
  checkbox.addEventListener('change', handleCheckboxChange);
});

// Call the initial checkbox check
handleCheckboxChange({ target: checkboxes[0] });

// Call the necessary functions to disable buttons instantly
if (!isCheckboxChecked()) {
  disableCheckoutButtons();
  disableDynamicCheckoutButtons();
}
